<template>
  <div class="row">
    <div
      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-0 check-text-center"
    >
      <h4 class="mb-0 worksansr">
        LISTA:
        <strong>{{ list ? list.description : "" }}</strong>
      </h4>
      <h4 class="m-0">
        {{ current_resident ? `RESIDENTE: ${current_resident.name}` : "" }}
      </h4>
    </div>
    <div
      class="col-xl-6 col-lg-6 col-md-6 col-sm-6 col-12 pb-0 check-text-right"
    >
      <confirmation-dialog
        v-if="residents.length > 1"
        :disabled="loading"
        message-title="PULAR RESIDENTE?"
        message-body="Não é possível retornar."
        open-text="PULAR RESIDENTE"
        open-class="btn-acess ml-2"
        header-class="modal-header-i"
        yesClass="btn-i worksansr"
        openRightIcon="fa-arrow-right ml-2"
        @yes="evOnFormNext"
      />
    </div>
    <div
      class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-12 pt-0 pb-0"
      v-if="current_resident_index < residents.length"
    >
      <list-with-props
        :firstanswer="firstanswer"
        :list="list"
        :resident="current_resident"
        :current="current_resident_index"
        :total="residents.length"
        @anwered="evOnFormAnswered"
        @return="emitReturn"
      />
    </div>
  </div>
</template>

<script>
import toast from "../../lib/ToastNotification";

import ConfirmationDialog from "../Components/ConfirmationDialog.vue";

import ListWithProps from "./ListWithProps.vue";

export default {
  name: "AnswerList",
  components: { ListWithProps, ConfirmationDialog },
  props: {
    list: [Object, undefined],
    residents: [Array, undefined],
  },
  data() {
    return {
      errors: [],

      loading: false,

      firstanswer: [],

      answered_ids: [],
      current_resident: undefined,
      current_resident_index: 0,
    };
  },
  watch: {
    residents: function () {
      this.answered_ids = [];
      this.current_resident_index = 0;
      this.current_resident = this.residents[this.current_resident_index];
    },
  },
  created() {
    this.answered_ids = [];
    this.current_resident_index = 0;
    this.current_resident = this.residents[this.current_resident_index];
  },
  methods: {
    async evOnFormAnswered(e) {
      let { answer } = e;

      this.firstanswer = answer;

      await this.evOnFormNext(true);
    },

    async evOnFormNext(answered = false) {
      if (answered) this.answered_ids.push(this.current_resident.id);
      else toast("RESIDENTE PULADO", "success");

      if (this.current_resident_index < this.residents.length - 1) {
        this.current_resident_index++;
        this.current_resident = this.residents[this.current_resident_index];
      } else {
        await this.emitReturn();
      }
    },

    async emitReturn() {
      this.$emit("return", {
        form_description: this.list.description,
        residents: this.residents.map((resident) => ({
          ...resident,
          answered: this.answered_ids.includes(resident.id),
        })),
      });
    },
  },
};
</script>

<style>
</style>